import React from "react";
import { uiNotification } from "../../../../../services/UINotificationService";
import { getPathParams } from "../utilities";
import { usePatientDocumentQuery } from "../../../../../api/patientDocuments/usePatientDocumentQuery";

export const withDocument = (Component) => (props) => {
  var { documentId } = getPathParams();

  var { data, isFetching } = usePatientDocumentQuery({
    payload: {
      documentId,
    },
    options: {
      enabled: !!documentId,
      onError: () => {
        uiNotification.error(
          "Unable to fetch document. Please try again later.",
        );
      },
    },
  });

  return (
    <Component
      {...props}
      document={data || {}}
      isDocumentLoading={isFetching}
    />
  );
};
